import {
    RELATIONSHIP_DETAILS_REQUEST,
    RELATIONSHIP_DETAILS_SUCCESS,
    RELATIONSHIP_DETAILS_FAIL,
    FETCH_RELATIONSHIPS_SUCCESS,
    FETCH_RELATIONSHIPS_FAIL,
    CREATE_RELATIONSHIP_SUCCESS,
    CREATE_RELATIONSHIP_FAIL,
    UPDATE_RELATIONSHIP_SUCCESS,
    UPDATE_RELATIONSHIP_FAIL,
    DELETE_RELATIONSHIP_SUCCESS,
    DELETE_RELATIONSHIP_FAIL,
    CREATE_RELATIONSHIP_RESET,
    FETCH_RELATIONSHIPS_REQUEST,
    CREATE_RELATIONSHIP_REQUEST,
  } from '../constants/relationshipConstants';
  
  export const relationshipDetailsReducer = (state = { relationship: {} }, action) => {
    switch (action.type) {
      case RELATIONSHIP_DETAILS_REQUEST:
        return { loading: true, ...state };
      case RELATIONSHIP_DETAILS_SUCCESS:
        return { loading: false, relationship: action.payload };
      case RELATIONSHIP_DETAILS_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  // Helper function to deduplicate relationships array
  const deduplicateRelationships = (relationships) => {
    if (!Array.isArray(relationships)) return [];
    
    const seen = new Map();
    const deduplicated = [];
    
    for (const rel of relationships) {
      if (!rel || !rel._id) continue;
      
      // Create unique key for deduplication
      let key;
      if (rel.uniqueNumber) {
        key = `unique_${rel.uniqueNumber}`;
      } else {
        // Normalize name: trim, lowercase, replace multiple spaces
        let name = '';
        if (rel.contractType === "Individual") {
          name = [rel.firstName, rel.middleName, rel.lastName]
            .filter(Boolean)
            .map(n => (n || '').trim())
            .join(' ')
            .toLowerCase()
            .replace(/\s+/g, ' ');
        } else {
          name = (rel.businessName || '').trim().toLowerCase().replace(/\s+/g, ' ');
        }
        const email = (rel.email || '').trim().toLowerCase();
        key = name ? (email ? `name_${name}_email_${email}` : `name_${name}`) : `id_${rel._id}`;
      }
      
      // Only add if we haven't seen this key before
      if (!seen.has(key)) {
        seen.set(key, true);
        deduplicated.push(rel);
      } else {
        // If duplicate found, prefer the one with uniqueNumber
        const existingIndex = deduplicated.findIndex(r => {
          const rKey = r.uniqueNumber 
            ? `unique_${r.uniqueNumber}`
            : (() => {
                let rName = '';
                if (r.contractType === "Individual") {
                  rName = [r.firstName, r.middleName, r.lastName]
                    .filter(Boolean)
                    .map(n => (n || '').trim())
                    .join(' ')
                    .toLowerCase()
                    .replace(/\s+/g, ' ');
                } else {
                  rName = (r.businessName || '').trim().toLowerCase().replace(/\s+/g, ' ');
                }
                const rEmail = (r.email || '').trim().toLowerCase();
                return rName ? (rEmail ? `name_${rName}_email_${rEmail}` : `name_${rName}`) : `id_${r._id}`;
              })();
          return rKey === key;
        });
        
        if (existingIndex >= 0 && rel.uniqueNumber && !deduplicated[existingIndex].uniqueNumber) {
          deduplicated[existingIndex] = rel; // Replace with version that has uniqueNumber
        }
      }
    }
    
    return deduplicated;
  };

  export const relationshipListReducer = (state = { relationships: [] }, action) => {
    switch (action.type) {
      case FETCH_RELATIONSHIPS_REQUEST:
        return { ...state, loading: true }; // Preserve existing relationships while loading
      case FETCH_RELATIONSHIPS_SUCCESS:
        console.log('🌐 Redux Reducer - FETCH_RELATIONSHIPS_SUCCESS');
        console.log('📦 Raw data from API:', {
          count: action.payload?.length || 0,
          data: action.payload
        });
        // Deduplicate relationships when fetching
        const dedupedData = deduplicateRelationships(action.payload);
        console.log('✨ After deduplication in reducer:', {
          count: dedupedData.length,
          removedDuplicates: (action.payload?.length || 0) - dedupedData.length
        });
        return { loading: false, relationships: dedupedData };
      case FETCH_RELATIONSHIPS_FAIL:
        return { loading: false, error: action.payload, relationships: state.relationships };
      case CREATE_RELATIONSHIP_SUCCESS:
        // Check if relationship already exists before adding
        const exists = state.relationships.some(r => r._id === action.payload._id);
        if (exists) {
          // Update existing instead of adding duplicate
          return {
            ...state,
            relationships: state.relationships.map(r => 
              r._id === action.payload._id ? action.payload : r
            )
          };
        }
        // Deduplicate after adding new relationship
        return { ...state, relationships: deduplicateRelationships([...state.relationships, action.payload]) };
      case UPDATE_RELATIONSHIP_SUCCESS:
        return {
          ...state,
          relationships: state.relationships.map((relationship) =>
            relationship._id === action.payload._id ? action.payload : relationship
          ),
        };
      case DELETE_RELATIONSHIP_SUCCESS:
        return {
          ...state,
          relationships: state.relationships.filter(
            (relationship) => relationship._id !== action.payload
          ),
        };
      default:
        return state;
    }
  };
  
  export const createRelationshipReducer = (state = {}, action) => {
    switch (action.type) {
      case CREATE_RELATIONSHIP_REQUEST:
        return { loading: true, };
      case CREATE_RELATIONSHIP_SUCCESS:
        return { loading: false, success: true, relationship: action.payload };
      case CREATE_RELATIONSHIP_FAIL:
        return { loading: false, error: action.payload };
      case CREATE_RELATIONSHIP_RESET:
        return {};
      default:
        return state;
    }
  };